import React from 'react';
import ItemStockStatus from '../../../../components-legacy/StockStatus';
import useContext from '../../../../hooks/useContext';
import Distance from '../../../../styled/Distance';
import { ProductContext } from '../providers/ProductProvider';

const StockStatus = () => {
  const { distributionType, moderArtikelId, configurationId, m3Id, variantId } =
    useContext(ProductContext);

  return (
    <>
      <Distance line="desktop" size={['2', '4']} />
      <ItemStockStatus
        configurationId={configurationId}
        distributionType={distributionType}
        m3Id={m3Id}
        moderArtikelId={moderArtikelId}
        variantId={variantId}
      />
    </>
  );
};

export default StockStatus;
